import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import SingleProduct from "./SingleProduct";
import { loadProductDetails } from "../../redux/actions";
import Preloader from "./Preloader";

const ProductDetailPage = () => {
  const { product_url } = useParams();
  const product_urls = decodeURIComponent(product_url);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fetchProductDetails = async () => {
      const data = await loadProductDetails(product_urls);
      const product = data?.page?.data?.product || {};
      setProduct(product);
      setLoading(false);
    };

    fetchProductDetails();
  }, [product_urls]);

  return (
    <section className="product-details py-30">
      <div className="container container-lg">
        <div className="row gy-4">
          {/* product detail */}
          {loading ? (
            <div className="preloader">
              <Preloader />
              {/* <img src="../../assets/images/icon/preloader.gif" alt="" /> */}
              {/* <i className="ph ph-spinner animate-spin text-2xl d-flex" /> */}
            </div>
          ) : (
            <div> </div>
          )}
          {product && <SingleProduct product={product} />}
        </div>
      </div>
    </section>
  );
};

export default ProductDetailPage;
